import { NEW_MEETINGS_PAGE } from "./props";
import { useIsFeatureEnabled } from "./useIsFeatureEnabled";

export function useNewMeetingsPage() {
  return useIsFeatureEnabled(NEW_MEETINGS_PAGE);
}
